<script setup lang="ts">
const { t } = useI18n();

interface Props {
  imagePath: string;
}

const props = defineProps<Props>();

const emits = defineEmits<(e: 'handleClearError') => void>();
</script>

<template>
  <div class="flex flex-col items-center justify-center h-screen bg-cover bg-top bg-[url('/errors/error-background.svg')] p-10">
    <div class="flex flex-col justify-center items-center">
      <img :src="imagePath" alt="error-404" class="mb-4 lg:mb-2.5" />
      <div class="text-center mb-4 lg:mb-7.5">
        <h1 class="text-white text-3xl xs:text-4xl lg:text-[40px] font-medium block ltr:first-letter:uppercase">
          {{t('errorPages.error404.title') }}
        </h1>
        <span class="text-white text-xs xs:text-sm lg:text-base">{{ t('errorPages.error404.desc') }}</span>
      </div>
      <UButton @click="emits('handleClearError')" size="xl" class="text-white bg-dark-purple bg-[length:200%_auto] bg-gradient-to-r from-dark-purple to-furious-purple ring-furious-purple">
        {{ t('label.back_to_home') }}
      </UButton>
    </div>
  </div>
</template>
